import React from "react";
import { ArrowRightIcon } from "lucide-react";
import type { CommunityEvent } from "../../types/content";
import { SiteLink } from "../SiteLink";
import { homeMedia } from "../../data/homeMedia";
type EventsSectionProps = {
  events: CommunityEvent[];
};
export function EventsSection({
  events
}: EventsSectionProps) {
  return <section aria-labelledby="events-title" className="bg-white" data-id="element-8" data-mp="36clbv62yt9bt">
      <div className="page-container py-12 md:py-16" data-id="element-9" data-mp="3kd5uo28vr55b">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between" data-id="element-10" data-mp="3kbuppz3p7rcm">
            <h2 id="events-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-11" data-mp="3fcqhbaollxnc">
              Michigan riding community
            </h2>
          <SiteLink path="/events/" className="inline-flex min-h-[48px] w-fit items-center gap-2 text-label font-bold text-ink underline underline-offset-4 hover:text-crimson" data-id="element-12" data-mp="3p4e3aw2dymhf">
            See all events
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-13" data-mp="21rie702ppmy" />
          </SiteLink>
        </div>

        <div className="mt-7 grid gap-8 md:grid-cols-2 md:gap-12" data-id="element-14" data-mp="32962f4uibis6">
          <div className="rounded-lg border border-line bg-ivory p-6 md:p-8" data-id="element-15" data-mp="377hcngoprvax">
            <p className="text-label font-bold text-crimson" data-id="element-16" data-mp="3c4zobeu48omm">Upcoming event</p>
            {events.length > 0 ? <div className="mt-4 divide-y divide-line" data-id="element-17" data-mp="3h5ncztuvgtdo">
                {events.map(event => <article key={event.id} className="py-2" data-id="element-18" data-mp="3l5610yhzpkkq">
                    <h3 className="text-h3 font-bold text-ink" data-id="element-19" data-mp="3q5ae0ejovx67">{event.title}</h3>
                    <p className="mt-4 font-semibold text-ink" data-id="element-20" data-mp="3q2xpfijfeok6"><time dateTime={event.isoStart} data-id="element-21" data-mp="3uvqt0335rquo">{event.dateLabel}</time></p>
                    <p className="mt-1 text-slate" data-id="element-22" data-mp="3pfy6ooqrmbs">{event.timeLabel}</p>
                    <p className="mt-2 text-slate" data-id="element-23" data-mp="3rsc8qrdpcjk">{event.venue}, {event.location}</p>
                    <SiteLink path={event.path} className="mt-4 inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-crimson underline underline-offset-4 hover:text-crimson-deep" data-id="element-24" data-mp="8qn6cousqniz">
                      Event details
                      <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-25" data-mp="24rx8yf3ikrjn" />
                    </SiteLink>
                  </article>)}
              </div> : <div className="mt-4" data-id="element-26" data-mp="2dsn4risryhxd">
                <h3 className="text-h3 font-bold text-ink" data-id="element-27" data-mp="2drkend3a0jii">No upcoming events are listed right now</h3>
                <p className="mt-3 text-slate" data-id="element-28" data-mp="2sgglj6tljqhj">Visit the events page for new listings.</p>
              </div>}
          </div>
          <figure className="w-full" data-id="element-29" data-mp="2nkj40x6lke36">
            <img src={homeMedia.community.src} width={homeMedia.community.width} height={homeMedia.community.height} alt={homeMedia.community.alt} data-media-id="baldwin-community-2019" loading="lazy" decoding="async" className="block aspect-[16/9] w-full rounded-lg border border-line object-cover object-[50%_35%]" data-id="element-30" data-mp="31ipuhs97vbst" />
            <figcaption className="mt-3 text-meta text-slate" data-id="element-31" data-mp="sz6ezsqmgnku">
              Baldwin Blessing of the Bikes, 2019. From The Motorcycle Lawyer’s{" "}
              <a href={homeMedia.community.sourceAlbum} target="_blank" rel="noopener noreferrer" className="font-semibold text-ink underline underline-offset-4 hover:text-crimson" data-id="element-32" data-mp="j93aowe1vn77">
                Facebook archive<span className="sr-only" data-id="element-33" data-mp="9axbimjmov61"> (opens in a new tab)</span>
              </a>
              .
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}